export enum CUSTOM_OBJECT_ASSOCIATION_RESULT {
  AssociatedWhoObject = 1,
  AssociatedWhatObject = 2,
  CouldNotAssociateObject = 3
}
